export const getMembershipIntegrationStatus = (currentOrganizer, locationKind) => {
  if (!currentOrganizer) { return false }

  const integrationStatuses = {
    zoom_conference: currentOrganizer.is_zoom_configured,
    gotomeeting_conference: currentOrganizer.is_gotomeeting_configured,
    microsoft_teams_conference: currentOrganizer.is_microsoft_teams_configured,
    webex_conference: currentOrganizer.is_webex_configured,
    google_conference: currentOrganizer.google_conferencing_configured
  }

  return integrationStatuses[locationKind] === false
}

export const isOrganizableConferenceLocation = (kind) => ([
  'zoom_conference',
  'google_conference',
  'microsoft_teams_conference',
  'webex_conference',
  'gotomeeting_conference'
].includes(kind))

export const extractIntegrationsStatus = (eventType, conferenceOrganizer) => {
  const calendarIntegrationStatusSourceObject = (eventType.id && eventType.pooling_type === 'collective')
    ? eventType
    : conferenceOrganizer

  return {
    zoom_conference: conferenceOrganizer?.is_zoom_configured,
    gotomeeting_conference: conferenceOrganizer?.is_gotomeeting_configured,
    google_conference: calendarIntegrationStatusSourceObject?.google_conferencing_configured,
    microsoft_teams_conference: calendarIntegrationStatusSourceObject?.is_microsoft_teams_configured,
    webex_conference: conferenceOrganizer?.is_webex_configured
  }
}
